export const THEME_ALIASES = {
  DARK: 'dark',
  LIGHT: 'light',
  BROWSER: '_browser_',
} as const;

export const DEFAULT_THEME = THEME_ALIASES.BROWSER;

export type ThemeAlias = (typeof THEME_ALIASES)[keyof typeof THEME_ALIASES];
export type Theme = Exclude<ThemeAlias, typeof THEME_ALIASES.BROWSER>;
